module.exports = __webpack_public_path__ + "07a16d594d089cfe027c84e96c682a6e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/closeCard.png
// module id = wZPM
// module chunks = 17